// src/hooks/useTheme.js
import { useState, useEffect } from 'react';
import { colorThemes, injectCSSVariables } from '../colors/theme';

export const useTheme = () => {
  // Sett tech som default tema i stedet for default
  const [currentTheme, setCurrentTheme] = useState(() => {
    return localStorage.getItem('selectedTheme') || 'tech';
  });

  // Tema informasjon for dropdown
  const themeInfo = [
    {
      id: 'tech',
      name: 'Teknologi',
      description: 'Blå og turkis - moderne og profesjonell',
      preview: ['#3b82f6', '#14b8a6', '#64748b'] // primary, accent, secondary
    },
    {
      id: 'default',
      name: 'Standard', 
      description: 'Rosa og lilla - elegant og feminin',
      preview: ['#ec4899', '#0ea5e9', '#64748b']
    },
    {
      id: 'nature',
      name: 'Natur',
      description: 'Grønn og gul - frisk og organisk', 
      preview: ['#22c55e', '#eab308', '#64748b']
    },
    {
      id: 'energy',
      name: 'Energi',
      description: 'Oransje og rød - varm og energisk',
      preview: ['#f97316', '#ef4444', '#64748b'] 
    },
    {
      id: 'nordic',
      name: 'Nordisk',
      description: 'Dempet og minimalistisk - skandinavisk design',
      preview: ['#64748b', '#ea7a47', '#737373']
    }
  ];

  // Funksjon for å endre tema
  const changeTheme = (themeId) => {
    if (colorThemes[themeId]) {
      setCurrentTheme(themeId);
      localStorage.setItem('selectedTheme', themeId);
      
      // Inject CSS-variabler og oppdater theme-color meta tag
      injectCSSVariables(themeId);
      
      console.log(`🎨 Tema endret til: ${themeId}`);
    }
  };

  // Initialiser tema ved første lasting
  useEffect(() => {
    // Sett tech som default hvis ingen tema er valgt
    const initialTheme = localStorage.getItem('selectedTheme') || 'tech';
    
    // Alltid inject CSS-variabler og oppdater theme-color ved oppstart
    injectCSSVariables(initialTheme);
    
    // Sett default tema i localStorage hvis det ikke finnes
    if (!localStorage.getItem('selectedTheme')) {
      localStorage.setItem('selectedTheme', 'tech');
    }
    
    console.log(`🚀 Tema initialisert: ${initialTheme}`);
  }, []);

  // Oppdater CSS-variabler når tema endres
  useEffect(() => {
    injectCSSVariables(currentTheme);
  }, [currentTheme]);

  return {
    currentTheme,
    themeInfo,
    changeTheme,
    getCurrentThemeObject: () => colorThemes[currentTheme],
    getColor: (colorName, shade = 500) => {
      const theme = colorThemes[currentTheme];
      return theme?.colors[colorName]?.[shade] || theme?.colors.primary[500];
    }
  };
};